import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ForeignLanguangeDTO  {
    _originalTypeClassName = "zERP.BO.ForeignLanguangeDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ForeignLanguangeDTO.translate = translateService;
}
this.Id = null;
this.DiplomaTitle = null;
this.ObtainingDate = null;
this.ExpiredDate = null;
this.DiplomaLink = null;
this.DocumentType = null;
this.DocumentDescription = null;
this.Diploma = null;
this.CEFRLevel = null;
this.CERFInt = null;
this.LanguageName = null;
this.InstitutionName = null;
this.CEFRName = null;
this.State = null;
this.HRComment = null;
this.EmpComment = null;
this.StateName = null;
this.StatePrevious = null;
this.Code = null;
this.ForeignLanguangeDTOKey = null;
this._key = this.ForeignLanguangeDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
DiplomaTitle:any;
ObtainingDate:any;
ExpiredDate:any;
DiplomaLink:any;
DocumentType:any;
DocumentDescription:any;
Diploma:any;
CEFRLevel:any;
CERFInt:any;
LanguageName:any;
InstitutionName:any;
CEFRName:any;
State:any;
HRComment:any;
EmpComment:any;
StateName:any;
StatePrevious:any;
Code:any;
Institution:any;
Language:any;
private _ForeignLanguangeDTOKey:any;
get ForeignLanguangeDTOKey(): any {
    return this._ForeignLanguangeDTOKey;
  }
set ForeignLanguangeDTOKey(value: any) {
    this._ForeignLanguangeDTOKey = value;
    this._key = value;
  }
static setInstitution = ($this, value) => {
var oldValue = $this.Institution;
$this.Institution = value;
if (value != null) {
}
}
static setLanguage = ($this, value) => {
var oldValue = $this.Language;
$this.Language = value;
if (value != null) {
}
}

static ParseCEFRLevel($this: any, db_level: any): any{return (db_level == Domain.CEFRLevel.A1 ? 0 : ((db_level == Domain.CEFRLevel.A2 ? 1 : ((db_level == Domain.CEFRLevel.B1 ? 2 : ((db_level == Domain.CEFRLevel.B2 ? 3 : ((db_level == Domain.CEFRLevel.C1 ? 4 : 5)))))))));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ForeignLanguangeDTOKey == null || $this.ForeignLanguangeDTOKey == 0;
            }


}